import React from 'react';
import {renderLines} from '../../helpers';

export default (props) => {
    return <div>
        <div className="syntax__edit-pane">
        {renderLines(61, '1200px')}
        {renderTheme(props.styles)}
        </div>
    </div>;
};

const renderTheme = (styles) => {
return <div style={styles.foreground}>&lt;?php<br />
<br />
<span style={styles.comment}>{'/**'}<br />
 &nbsp;* Keyboard Shortcuts:<br />
 &nbsp;*<br />
 &nbsp;* [up/down] &nbsp;&nbsp;&nbsp;- Switch Theme.<br />
 &nbsp;* [left/right] - Switch Language.<br />
 &nbsp;* [n/c/l] &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Switch Theme Type.<br />
 &nbsp;{'*/'}</span><br />
<br />
<span style={styles.keyword}>namespace</span> Illuminate\Container;<br />
<br />
<span style={styles.keyword}>use</span> Closure;<br />
<span style={styles.keyword}>use</span> ArrayAccess;<br />
<span style={styles.keyword}>use</span> LogicException;<br />
<br />
<span style={styles.keyword}>class</span> Container <span style={styles.function}>implements</span> ArrayAccess, ContainerContract<br />
{'{'}<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.comment}>{'/**'}<br />
&nbsp;&nbsp;&nbsp;&nbsp; * The current globally available container (if any).<br />
&nbsp;&nbsp;&nbsp;&nbsp; *<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @var static<br />
&nbsp;&nbsp;&nbsp;&nbsp; */</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>protected static</span> $instance;<br />
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.comment}>{'/**'}<br />
&nbsp;&nbsp;&nbsp;&nbsp; * An array of the types that have been resolved.<br />
&nbsp;&nbsp;&nbsp;&nbsp; *<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @var array<br />
&nbsp;&nbsp;&nbsp;&nbsp; */</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>protected</span> $resolved <span style={styles.function}>=</span> [];<br />
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.comment}>{'/**'}<br />
&nbsp;&nbsp;&nbsp;&nbsp; * The container's bindings.<br />
&nbsp;&nbsp;&nbsp;&nbsp; *<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @var array<br />
&nbsp;&nbsp;&nbsp;&nbsp; */</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>protected</span> $bindings <span style={styles.function}>=</span> [];<br />
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.comment}>{'/**'}<br />
&nbsp;&nbsp;&nbsp;&nbsp; * Determine if the given abstract type has been resolved.<br />
&nbsp;&nbsp;&nbsp;&nbsp; *<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @param  string  $abstract<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @return bool<br />
&nbsp;&nbsp;&nbsp;&nbsp; */</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>public</span> <span style={styles.keyword}>function</span> <span style={styles.functionName}>resolved</span>($abstract)<br />
&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>if</span> ($this<span style={styles.function}>-></span><span style={styles.functionName}>isAlias</span>($abstract)) {'{'}<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$abstract <span style={styles.function}>=</span> $this<span style={styles.function}>-></span><span style={styles.functionName}>getAlias</span>($abstract);<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>return</span> <span style={styles.keyword}>isset</span>($this<span style={styles.function}>-></span>resolved[$abstract]) <span style={styles.function}>||</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.keyword}>isset</span>($this<span style={styles.function}>-></span>instances[$abstract]);<br />
&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.comment}>{'/**'}<br />
&nbsp;&nbsp;&nbsp;&nbsp; * Determine if a given type is shared.<br />
&nbsp;&nbsp;&nbsp;&nbsp; *<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @param  string  $abstract<br />
&nbsp;&nbsp;&nbsp;&nbsp; * @return bool<br />
&nbsp;&nbsp;&nbsp;&nbsp; */</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>public</span> <span style={styles.keyword}>function</span> <span style={styles.functionName}>isShared</span>($abstract)<br />
&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={styles.function}>return</span> <span style={styles.keyword}>isset</span>($this<span style={styles.function}>-></span>instances[$abstract]) <span style={styles.function}>||</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(<span style={styles.keyword}>isset</span>($this<span style={styles.function}>-></span>bindings[$abstract][<span style={styles.string}>'shared'</span>]) <span style={styles.function}>&&</span><br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$this<span style={styles.function}>-></span>bindings[$abstract][<span style={styles.string}>'shared'</span>] <span style={styles.function}>=== true</span>);<br />
&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
{'}'}
</div>
}




// WEBPACK FOOTER //
// ./src/components/syntax/PHP.js